var _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: style */
function SvgClose(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    id: "close_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    xmlSpace: "preserve"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    transform: "rotate(-45.001 10.042 9.992)",
    className: "close_svg__st0",
    d: "M9.5-2.5h1v25h-1z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    transform: "rotate(-134.999 10.042 9.992)",
    className: "close_svg__st0",
    d: "M9.5-2.5h1v25h-1z"
  })));
}
export default SvgClose;